<template>
  <div class="goodDetail">
    <div class="bookBanner">
      <van-swipe :autoplay="3000" indicator-color="#e4393c">
        <van-swipe-item v-for="(item, index) in images" :key="index" style="text-align:center">
          <img :src="item" style="padding:20px 0" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="bookdetail">
      <div class="price">
        <div>
          <span class="price2" style="color:#e4393c;padding-left: 0;">￥</span>
          <span v-html="newPrice"></span>
          <span class="price2">定价</span>
          <span class="price2" style="text-decoration-line: line-through;padding-left: 0;">¥{{ list.originalPrice
          }}</span>
        </div>
        <img :src="notCollected" style="width:30px;height:30px;vertical-align: bottom;" />
      </div>
      <div class="bookName">
        {{ list.name }}
      </div>
      <div class="hotPoint">
        {{ list.description }}
      </div>
    </div>
    <div class="author">
      <div v-for="(item, index) in attributes" :key="index">
        <div v-if="item.name == '作者'" class="attrItem">
          <span>{{ item.name }}</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
      <div v-for="item in attributes" :key="item.name">
        <div v-if="item.name == '出版社'" class="attrItem">
          <span>{{ item.name }}</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
      <div class="attrItem">
        <span>分类</span>
        <span>{{ list.productCategoryName }}</span>
      </div>
    </div>
    <div class="addr">
      <div class="attrItem">
        <span>选择</span>
        <span>已选：1件</span>
      </div>
      <div class="attrItem" style="display:grid;grid-template-columns: 40px auto 20px;align-items: center;">
        <span>送至</span>
        <div style="display:grid;grid-template-columns: 16px auto;align-items: center;">
          <img style="width:16px;height:16px" src="@/assets/image/info_address.svg" />
          <span class="van-ellipsis" style="padding-left:5px;color: #999999;">请选择</span>
        </div>
        <img style="width:14px;height:14px;justify-self: flex-end;" @click="toDownLoad"
          src="@/assets/image/more_black.svg" />
      </div>
      <div class="attrItem" style="display:grid;grid-template-columns: 43px auto 20px;align-items: center;">
        <span>保障</span>
        <div style="overflow:hidden">
          <span style="color:#333">7天无理由退换货</span>
          <span style="padding-left: 12px;">48小时内发货</span>
          <span style="padding-left: 12px;">售后无忧</span>
        </div>
        <img style="width:14px;height:14px;justify-self: flex-end;" @click="show = true"
          src="@/assets/image/more_black.svg" />
      </div>
    </div>
    <div class="comment">
      <div class="infoTips">
        <span>评价<span v-if="comments.commentStatistics" style="font-size:10px;font-weight: normal;color:#666666">（{{
        comments.commentStatistics.commentNum
        }}）</span></span>
        <span v-if="comments.commentStatistics" style="font-size:12px;font-weight: normal;color:#666666">好评度{{
        comments.commentStatistics.highlyPraise
        }}</span>
      </div>
      <div v-for="item in comments.commentList" :key="item.id" style="margin-bottom:16px" @click="toDownLoad">
        <div class="commentUser">
          <img :src="item.umbiLogo" :onerror="head" />
          <div style="color:#999999;font-size:14px">
            <div>{{ item.umbiName }}</div>
            <van-rate v-model="item.star" readonly size="15px" />
          </div>
          <div style="text-align: right; color: #999999;font-size: 12px;">
            {{ item.createTime.slice(0, 10) }}
          </div>
        </div>
        <div class="commentContent van-multi-ellipsis--l2">
          {{ item.content }}
        </div>
        <div class="commentPics" v-if="item.pics && item.pics.length != 0">
          <div style="height: calc((100vw - 56px - 4vw ) / 3);overflow: hidden;" v-for="(e, index) in item.pics"
            :key="index">
            <img :src="e" />
          </div>
        </div>
      </div>
      <div class="allComment" v-if="comments.commentList">
        <van-button v-if="comments.commentList.length != 0" color="#999999" plain round @click="toDownLoad">
          <span style="color:#333">查看全部评论</span></van-button>
        <span v-else>还没有评价</span>
      </div>
    </div>
    <div class="bookContent">
      <div class="infoTips">商品详情</div>
      <div v-html="list.detailDesc"></div>
    </div>
    <div class="parameter">
      <div class="infoTips">规格参数</div>
      <div class="parameter-table">
        <div class="infoTable">
          <div class="infoOne"><span style="align-self:center">商品编号</span></div>
          <div class="infoOne" style="border:none"><span style="align-self:center">{{ list.itemNumber }}</span></div>
        </div>
        <div class="infoTable" style="border-top:1px solid #999">
          <div class="infoOne" style="border:none;font-weight: bold;"><span style="align-self:center">基本信息</span>
          </div>
        </div>
        <div v-for="(item, index) in attributes" :key="index">
          <div class="infoTable" v-if="item.name != '作者' && item.name != '出版社'" style="border-top:1px solid #999">
            <div class="infoOne"><span style="align-self:center">{{ item.name }}</span></div>
            <div class="infoOne" style="border:none"><span style="align-self:center">{{ item.value }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footIcon">
        <div style="text-align:center" @click="toDownLoad">
          <img src="@/assets/image/kf.svg" />
          <div style="margin-top: 6px;">客服</div>
        </div>
        <div style="text-align:center" @click="toDownLoad">
          <img src="@/assets/image/tabbar_shoppingCar.svg" />
          <div style="margin-top: 6px;">购物车</div>
        </div>
      </div>
      <div class="footBtn">
        <van-button round color="#ffbd1f" @click="toDownLoad">加入购物车</van-button>
        <van-button round color="#e4393c" @click="toDownLoad">立即购买</van-button>
      </div>
    </div>
    <!-- 保障 -->
    <van-action-sheet v-model="show" title="保障">
      <div style="padding: 15px">
        <div style="padding-bottom: 18px">
          <p style="font-size: 15px; font-weight: bold; padding-bottom: 5px">
            享受无忧
          </p>
          <p style="color: grey">为平台产品用户提供无忧服务</p>
        </div>
        <div>
          <p style="font-size: 15px; font-weight: bold; padding-bottom: 8px">
            保障说明
          </p>
          <div style="padding-bottom: 15px">
            <p style="font-size: 13px; padding-bottom: px">
              <van-icon name="after-sale" color="red" size="18" />&nbsp;7天无理由退换货
            </p>
            <p style="color: grey">支持7天~</p>
          </div>
          <div style="padding-bottom: 15px">
            <p style="font-size: 13px; padding-bottom: 8px">
              <van-icon name="guide-o" color="red" size="18" />&nbsp;48小时发货
            </p>
            <p style="color: grey">48小时发货~</p>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "GoodsDetail",
  data() {
    return {
      notCollected: require('@/assets/image/info_notCollected.svg'),
      list: {},
      attributes: [], //商品属性
      images: [],
      show: false,
      comments: [], //评价
      badgeNum: 0,
      newPrice: 0,
      head: 'this.src="' + require("@/assets/image/tx3.svg") + '"',
    };
  },
  mounted() {
    const that = this;
    let id = that.$route.query.id;
    let param = {
      productId: id,
      userId: "",
    };
    that.getDataDetails(param);
    that.getCommentList(parseInt(id));
  },
  methods: {
    //处理价格
    updatePrice(val) {
      let priceList = val.split(".");
      this.newPrice = `${priceList[0]}.<span style="font-size:13px;">${priceList[1]}</span>`;
    },
    //获取页面详情
    getDataDetails(val) {
      Axios.post(this.$store.state.CSSCAPIURL + "app/productInfo/info", val).then((res) => {
        this.list = res.data.data;
        this.updatePrice(this.list.salePrice);
        if (this.list.attribute) {
          let tt = JSON.parse(this.list.attribute)
          for (let i in tt) {
            this.attributes.push({
              name: i,
              value: tt[i]
            })
          }
        }
        this.images = this.list.albumPics.split(",");
      });
    },
    //获取评价
    getCommentList(val) {
      Axios.get(
        this.$store.state.CSSCAPIURL + "app/productComment/" + val
      ).then((res) => {
        if (res.data.code == 200) {
          this.comments = res.data.data;
          res.data.data.commentList.forEach(e => {
            if (e.pics) {
              e.pics = e.pics.split(',')
            }
          })
        }
      });
    },
    //下载页
    toDownLoad() {
      location.href='http://url.cn/59TtsAP';
    },
  },
};
</script>

<style lang="less">
.goodDetail {
  padding-bottom: 70px;
  background-color: #fafafa;

  .bookBanner {
    background-color: #ffffff;
    margin-bottom: 10px;

    img {
      width: 100%;
      height: auto;
    }
  }

  .bookdetail {
    background-color: #ffffff;
    margin: 0 10px 10px;
    padding: 18px;
    border-radius: 6px;

    .price {
      color: #e4393c;
      font-size: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .price2 {
        font-size: 10px;
        color: #999999;
        padding-left: 10px;
      }
    }

    .bookName {
      font-size: 16px;
      padding-bottom: 10px;
      color: #333333;
      font-weight: bold;
      line-height: 1.5;
    }

    .hotPoint {
      font-size: 12px;
      color: #999999;
      line-height: 1.5;
    }
  }

  .author {
    background-color: #ffffff;
    margin: 0 10px 10px;
    padding: 18px 18px 2px;
    border-radius: 6px;
    font-size: 14px;
  }

  .attrItem {
    padding-bottom: 16px;

    span {
      &:first-child {
        color: #666666;
      }

      &:last-child {
        color: #333333;
        padding-left: 16px;
      }
    }
  }

  .addr {
    background-color: #ffffff;
    margin: 0 10px 10px;
    padding: 18px 10px 2px 18px;
    border-radius: 6px;
    font-size: 14px;
  }

  .tips {
    text-align: center;
    font-size: 16px;
    color: #333333;
    padding: 30px 0;
  }

  .userAddr {
    display: grid;
    grid-template-columns: 10% 90%;
    align-items: center;
    margin-bottom: 30px;
  }

  .comment {
    background-color: #ffffff;
    margin: 0 10px 10px;
    padding: 18px;
    border-radius: 6px;
    font-size: 14px;

    .commentUser {
      display: grid;
      grid-template-columns: 45px auto 90px;
      align-items: center;
      margin-bottom: 12px;

      img {
        width: 35px;
        height: 35px;
        border-radius: 50%;
      }
    }

    .commentContent {
      margin-bottom: 10px;
      color: #333333;
    }

    .commentPics {
      display: grid;
      grid-template-columns: repeat(3, 32%);
      gap: 2%;

      img {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 32vw;
        overflow-y: hidden;
      }
    }

    .allComment {
      text-align: center;
      color: #333;
    }
  }

  .infoTips {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
  }

  .bookContent,
  .parameter {
    background-color: #ffffff;
    margin: 0 10px 10px;
    padding: 18px;
    border-radius: 6px;
    font-size: 14px;

    img {
      width: 100%;
    }

    .parameter-table {
      font-size: 14px;
      border: 1px solid #999;
      color: #999;

      .infoTable {
        display: grid;
        grid-template-columns: 35% 65%;
        height: 50px;

        .infoOne {
          border-right: 1px solid #999;
          padding: 0 12px;
          display: flex;
        }
      }
    }
  }

  .footer {
    background-color: #ffffff;
    padding: 0 10px;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    display: grid;
    grid-template-columns: 30% 70%;
    align-items: center;

    .footIcon {
      display: flex;
      justify-content: space-around;
      font-size: 10px;
      color: #666666;

      img {
        width: 18px;
        height: 18px;
        vertical-align: bottom;
      }
    }

    .footBtn {
      display: flex;
      justify-content: space-between;
      padding-left: 30px;

      .van-button {
        width: 45%;
      }
    }
  }

  .shoppingCar {
    padding: 16px 16px 10px;

    .commodity {
      display: grid;
      grid-template-columns: 30% 66%;
      gap: 4%;

      img {
        width: 100%;
        height: auto;
      }

      .commodityInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .name {
          font-size: 16px;
          color: #333333;
          line-height: 1.5;
        }

        .price {
          font-size: 16px;
          font-weight: 600;
          color: #e4393c;
        }
      }
    }

    .count {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
  }
}
</style>
